import React from 'react';
import { Button } from '@mui/material';
import DraftsIcon from '@mui/icons-material/Drafts';
import { H4, Body2, Body3 } from '../../themes/typography';
import '../../styles/components/RedirectToTicket.css';
import Popup from '../Dialog/RedirectToTicket';

function RedirectToTicket() {
    return (
        <React.Fragment>
            <Popup />
            <section id="redirect-to-ticket-section">
                <div className="redirect-content-container">
                    <div className="event-success-message-container">
                        <DraftsIcon sx={{ fontSize: '4rem', color: '#f8a21e' }} />
                        <div className="event-created-messages">
                            <H4>Event created successfully</H4>
                            <Body2>
                                Your event has been created successfully and it is saved as a draft.
                                You need to create a ticket for this event to make it publish.
                            </Body2>
                        </div>
                    </div>
                    <div className="ticket-creation-notes-container">
                        <H4>Would you like to create a ticket for this event?</H4>
                        <ul className="ticket-creation-notes">
                            <li>
                                <Body3 fontWeight={400}>
                                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                    Veritatis non incidunt culpa dolor delectus quod hic velit
                                    consequatur beatae qui.
                                </Body3>
                            </li>
                            <li>
                                <Body3 fontWeight={400}>
                                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                    Veritatis non incidunt culpa dolor delectus quod hic velit
                                    consequatur beatae qui.
                                </Body3>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="redirect-action-btns">
                    <Button variant="text">Skip for now</Button>
                    <Button variant="main">Create Ticket</Button>
                </div>
            </section>
        </React.Fragment>
    );
}

export default RedirectToTicket;
